/**
 * authStorage.ts
 *
 * Armazenamento da sessão que respeita o "Manter-me conectado" do login.
 *   remember=true  -> localStorage   (sobrevive ao fechar o navegador)
 *   remember=false -> sessionStorage (some ao fechar a aba/navegador)
 *
 * Os leitores não precisam saber onde o valor está: getItem procura primeiro na
 * sessionStorage e depois na localStorage. setItem grava no destino escolhido e
 * remove a cópia do outro para não deixar valor obsoleto.
 */

export const authStorage = {
  getItem(key: string): string | null {
    return sessionStorage.getItem(key) ?? localStorage.getItem(key);
  },

  setItem(key: string, value: string, remember: boolean): void {
    const target = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    target.setItem(key, value);
    other.removeItem(key);
  },

  removeItem(key: string): void {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },
};
